/**
 * StaffGateway の Supabase 実装（Edge Function）。
 */
import { supabase } from "@/integrations/supabase/client";
import type {
  CreateStaffUserBody,
  StaffGateway,
} from "@/domain/repositoryInterface/StaffGateway";

export class SupabaseStaffGateway implements StaffGateway {
  async createStaffUser(body: CreateStaffUserBody): Promise<unknown> {
    const { data, error } = await supabase.functions.invoke("create-staff-user", {
      body,
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data.staff;
  }
}
